import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "material-icon-folder",
  "use": "material-icon-folder-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"material-icon-folder\"><path d=\"M15.075 3h-7.39c-.073-.208-.157-.416-.212-.634C7.288 1.762 7.12 1 6.4 1H.925C.416 1 0 1.446 0 1.99v11.02c0 .545.416.99.925.99h14.15c.509 0 .925-.445.925-.99V3.99c0-.544-.416-.99-.925-.99z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol